import Documento from './Documento'

class Edicao {
    constructor(
        {
            id = null, 
            numero_edicao = null, 
            tipo_edicao = null, 
            ano_romanos_edicao = null, 
            dt_publicacao = null, 
            hr_publicacao = null, 
            capa_documento_id = null, 
            jornal_documento_id = null,  
            dt_criacao = null, 
            dt_atualizacao = null, 
            
            arquivo_capa = null,
            arquivo_jornal = null,

            documento_capa = {},
            documento_jornal = {},

        } = {}
    ) {
        this.id = id; 
        this.numero_edicao = numero_edicao; 
        this.tipo_edicao = tipo_edicao; 
        this.ano_romanos_edicao = ano_romanos_edicao; 
        this.dt_publicacao = dt_publicacao; 
        this.hr_publicacao = hr_publicacao; 
        this.capa_documento_id = capa_documento_id; 
        this.jornal_documento_id = jornal_documento_id;  
        this.dt_criacao = dt_criacao; 
        this.dt_atualizacao = dt_atualizacao; 
        
        this.arquivo_capa = arquivo_capa; 
        this.arquivo_jornal = arquivo_jornal; 
 
        this.documento_capa = documento_capa ? new Documento(documento_capa) : new Documento(); 
        this.documento_jornal = documento_jornal ? new Documento(documento_jornal) : new Documento();     
    }
}

export default Edicao;